import { render, staticRenderFns } from "./SummaryPanel.vue?vue&type=template&id=f91ebb2c&scoped=true&lang=pug&"
import script from "./SummaryPanel.vue?vue&type=script&lang=js&"
export * from "./SummaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./SummaryPanel.vue?vue&type=style&index=0&id=f91ebb2c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91ebb2c",
  null
  
)

export default component.exports